// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketTwoToneSvg from "@fishx/icons-svg/es/asn/RocketTwoTone";
import FishxIcon from '../components/FishxIcon';

var RocketTwoTone = function RocketTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketTwoToneSvg
  }));
};

RocketTwoTone.displayName = 'RocketTwoTone';
export default React.forwardRef(RocketTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RocketTwoTone.js
// module id = 4033
// module chunks = 0